import { TipoAvaliacao } from '../../types/tipo-avaliacao.types';

export class TemaCalendarioAvaliacao {
  codigo?: string;
  nome?: string;
  ordemApresentacao?: number;

  constructor(codigo?: string, nome?: string, ordemApresentacao?: number) {
    this.codigo = codigo;
    this.nome = nome;
    this.ordemApresentacao = ordemApresentacao;
  }
}

export enum AvaliacaoOrigin {
  JUCA = 'JUCA',
  QCONCURSOS = 'QCONCURSOS',
}

export interface CalendarioAvaliacao {
  id: string;
  marca?: string;
  codigoDisciplina: string;
  temas?: Array<TemaCalendarioAvaliacao>;
  tipoAvaliacao?: TipoAvaliacao;
  origin?: AvaliacaoOrigin;
  tituloAvaliacao?: string;
  disponibilidadeAvaliacaoInicio?: Date;
  disponibilidadeAvaliacaoFim?: Date;
  tempoDuracaoMinutos?: number;
  codigoPeriodo?: string;
  quantidadeQuestoes?: number;
  quantidadeAcertos?: number;
  execucaoAvaliacaoInicio?: Date;
  execucaoAvaliacaoFim?: Date;
  avaliacaoAplicadaId?: string;
}

export interface Supplier {
  id: (param: string) => Supplier;
  marca: (param: string) => Supplier;
  codigoDisciplina: (param: string) => Supplier;
  temas: (param: TemaCalendarioAvaliacao[]) => Supplier;
  quantidadeAcertos: (param: number | undefined) => Supplier;
  quantidadeQuestoes: (param: number | undefined) => Supplier;
  tipoAvaliacao: (param: TipoAvaliacao) => Supplier;
  origin: (param: AvaliacaoOrigin) => Supplier;
  tituloAvaliacao: (param: string) => Supplier;
  disponibilidadeAvaliacaoInicio: (param: Date | undefined) => Supplier;
  disponibilidadeAvaliacaoFim: (param: Date | undefined) => Supplier;
  execucaoAvaliacaoInicio: (param: Date | undefined) => Supplier;
  execucaoAvaliacaoFim: (param: Date | undefined) => Supplier;
  avaliacaoAplicadaId: (param: string) => Supplier;
  tempoDuracaoMinutos: (param: number | undefined) => Supplier;
  codigoPeriodo: (param: string) => Supplier;
  get: () => CalendarioAvaliacao;
}

export interface FixtureCalendarioAvaliacaoResult {
  create: () => Supplier;
}

export type FixtureCalendarioAvaliacao = () => FixtureCalendarioAvaliacaoResult;
